/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import UIToggle from './ui/UIToggle';
import UIInputText from './ui/UIInputText';
import UIInputColor from './ui/UIInputColor';
import UITextArea from './ui/UITextArea';

// import uuid from 'uuid/v4';

const TableList = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const initialState = {
    type: 'TableList',
    columnTitles: { en: '' },
    rowsData: '',
    hasSearch: false,
    hasSort: false,
    altRowColor: '#FFFFFF',
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [updatedData, setUpdatedData] = useState(false);

  const [columnTitles, setColumnTitles] = useState({ en: '' });
  const [rowsData, setRowsData] = useState('');
  const [hasSearch, setHasSearch] = useState(false);
  const [hasSort, setHasSort] = useState(false);
  const [altRowColor, setAltRowColor] = useState('#FFFFFF');

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {

        const {
          columnTitles: currentColumnTitles,
          rowsData: currentRowsData,
          hasSearch: currentHasSearch,
          hasSort: currentHasSort,
          altRowColor: currentAltRowColor,
        } = component;

        setState(component);
        currentColumnTitles && setColumnTitles(currentColumnTitles);
        currentRowsData && setRowsData(currentRowsData);
        setHasSearch(currentHasSearch);
        setHasSort(currentHasSort);
        setAltRowColor(currentAltRowColor);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      columnTitles,
      rowsData,
      hasSearch,
      hasSort,
      altRowColor,
    }

    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    columnTitles,
    rowsData,
    hasSearch,
    hasSort,
    altRowColor,
  ]);

  const columnTitlesChange = (value) => {
    columnTitles[activeLanguage] = value
    setColumnTitles({ ...columnTitles });
  }

  const returnCurrentLanguage = (value) => {
    return value[activeLanguage] ? value[activeLanguage] : '';
  }

  return (
    <div className="flex justify-start flex-col text-black">
      <div className="pb-4 w-full">
          <div className="w-full md:mb-0 text-black">
          <UIInputText
            label='Column Titles (Comma separated)'
            setValue={columnTitlesChange}
          value={returnCurrentLanguage(columnTitles)}
          />
          <UITextArea
            label='Rows Data (Comma separated)'
            setValue={setRowsData}
            value={rowsData}
          />
          </div>
          <div className="bg-blue-lightest flex flex-row p-6 rounded">
            <UIInputColor
              label='Alternative Color for even rows'
              setValue={setAltRowColor}
              value={altRowColor}
            />
            <UIToggle
                title='Searchable'
                setValue={setHasSearch}
                value={hasSearch}
              />
            <UIToggle
                title='Columns sortable'
                setValue={setHasSort}
                value={hasSort}
            />
          </div>
      </div>
    </div>
  );
};

TableList.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
TableList.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default TableList;
